import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function PhotoManagerRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.PhotoManager', {
		url: '/admin/photo_manager',
		controllerAs: 'vm',
		controller: PhotoManagerCtrl,
		templateUrl: '/ng/hub/Photo/Manager/PhotoManagerCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Photo/Manager/PhotoManagerCtrl.css'),
			$title: () => 'Photo Manager Admin',
		},
	});
}

export class PhotoManagerCtrl {
	constructor(Api) {
		'ngInject';
		this.name = 'Photo Manager';
		this.Api = Api;
		this.mode = null;
		this.term = null;
		this.uuid = null;
		this.photos = [];
		this.photo = null;
		this.url = null;
		this.tags = [];
		this.message = null;
	}

	list() {
		this.Api.get('/v2/photos').then(
			list => {
				this.mode = 'list';
				this.photos = [];

				for (const model of list) {
					this.photos.push(new Photo(model));
				}
			},
			err => {
				console.log(err);
			}
		);
	}

	search() {
		const params = { tags: this.term };

		this.Api.get('/v2/photos/search', params).then(
			list => {
				this.mode = 'list';
				this.photos = [];

				for (const model of list) {
					this.photos.push(new Photo(model));
				}
			},
			err => {
				console.log(err);
			}
		);
	}

	fetch() {
		this.Api.get(`/v2/photos/${this.uuid}`).then(
			model => {
				this.mode = 'model';

				try {
					this.photo = new Photo(model);
				} catch (err) {
					this.photo = null;
					this.message = `UUID: ${this.uuid}. ${err}`;
				}
			},
			err => {
				console.log(err);
			}
		);
	}

	add() {
		const tags = this.tags.map(input => input.name);

		if (this.url && tags.length > 0) {
			this.Api.post('/v2/photos', { url: this.url, tags: tags })
				.then(
					model => {
						this.mode = 'model';

						try {
							this.photo = new Photo(model);
						} catch (err) {
							this.photo = null;
							this.message = 'Unable to add photo to database.';
						}
					},
					err => {
						console.log(err);
					}
				)
				.finally(() => {
					this.url = null;
					this.tags = [];
				});
		}
	}

	curate() {
		if (this.uuid && this.tags.length > 0) {
			this.Api.patch(`/v2/photos/${this.uuid}`, { tags: this.tags }).then(
				model => {
					try {
						let photo = new Photo(model);

						if (this.mode === 'list') {
							const targetIndex = this.photos.findIndex(photo => photo.uuid === uuid);

							if (targetIndex > -1) {
								this.photos[targetIndex] = photo;
							} else {
								this.photos.push(photo);
							}
						}
					} catch (err) {
						alert('ERROR: Unable to update photo tags!');
					}
				},
				err => {
					console.log(err);
				}
			);
		}
	}

	remove(uuid) {
		if (confirm('Are you sure you want to delete this Photo?')) {
			this.Api.delete(`/v2/photos/${uuid}`).then(
				model => {
					if (model && typeof model === 'object' && model.success) {
						if (this.mode === 'list') {
							this.photos = this.photos.filter(photo => photo.uuid !== uuid);
						}
					} else {
						alert('ERROR: Unable to remove photo!');
					}
				},
				err => {
					console.log(err);
				}
			);
		}
	}
}

class Photo {
	constructor(model) {
		if (typeof model === 'object' && model.hasOwnProperty('uuid') && model.hasOwnProperty('url')) {
			this.uuid = model.uuid;
			this.url = model.url;
			this.contentTags = model.contentTags;
		} else {
			throw model.toString();
		}
	}
}
